import _classCallCheck from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/**
 * HTTPError.js
 *
 * Copyright (c) apploft. GmbH
 */
var HTTPError = /*#__PURE__*/function (_Error) {
  _inherits(HTTPError, _Error);

  var _super = _createSuper(HTTPError);

  function HTTPError(message, _ref) {
    var _this;

    var url = _ref.url,
        info = _ref.info,
        status = _ref.status,
        opts = _ref.opts;

    _classCallCheck(this, HTTPError);

    _this = _super.call(this, message);
    _this.status = status;
    _this.info = info;
    _this.url = url;
    _this.opts = opts;
    return _this;
  }

  return HTTPError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { HTTPError as default };